import type {SmartEvt10, SmartEvt11, SmartPv12} from '@smart/analytics';
import {EventSource, EventType, useCoreAnalytics} from '@smart/analytics';
import {useFeatureAppEnv} from '@smart/feature-app/react';

enum EventRegion {
  STOCK_SEARCH = `stock_search`,
}

enum PageName {
  STOCK_SEARCH = `stock_search`,
}
enum PageType {
  PRODUCT_LIST = `product_list`,
}

export enum EventName {
  ADD_TO_CART = `add_to_cart`,
  MORE_INFO = `more_info`,
  REMOVE_FILTER = `remove.{filterName}`,
  SORT = `sort`,
  RESET = `reset`,
  MANUAL = `manual`,
  LAZY_LOAD = `lazy_load`,
}
type CreatePageView = Omit<SmartPv12['page'], 'type' | 'name'>;

export const createPageView = (data: CreatePageView): SmartPv12['page'] => ({
  ...data,
  type: PageType.PRODUCT_LIST,
  name: PageName.STOCK_SEARCH,
});

type CreateNavigationEvent = Omit<
  SmartEvt10['eventInfo'],
  'type' | 'region' | 'name'
> & {
  name: EventName;
};

export const createNavigationEvent = (
  data: CreateNavigationEvent,
): SmartEvt10['eventInfo'] => ({
  ...data,
  region: EventRegion.STOCK_SEARCH,
  type: EventSource.NAVIGATION,
});

type CreateFilterEvent = Omit<
  SmartEvt11['eventInfo'],
  'type' | 'region' | 'name'
> & {
  name: EventName;
};

export const createFilterEvent = (
  data: CreateFilterEvent,
): SmartEvt11['eventInfo'] => ({
  ...data,
  region: EventRegion.STOCK_SEARCH,
  type: EventSource.FILTER,
});

export const useTracking = () => {
  const analytics = useCoreAnalytics(useFeatureAppEnv, `sales_tool`);

  return {
    pageView: (page: SmartPv12['page']) => {
      analytics<SmartPv12>({page}, EventType.PAGEVIEW);
    },
    event: (eventInfo: SmartEvt10['eventInfo'] | SmartEvt11['eventInfo']) => {
      analytics({eventInfo} as SmartEvt10, EventType.CLICK);
    },
  };
};
